// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/MoreActions/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content_Content_Content_Content_MoreActions($image_series_id: numeric!) {
  vaxiom_patient_imageseries_by_pk(id: $image_series_id) {
    id
    series_date
    name
    deleted
    treatment_id
    appointment_id
  }
}

`